<template>
  <div>
    <RDSGraph
      :graphConfig="getGraphTemplate"
      :index="graphIndex"
      :label="graphLegends"
      :sliceGraphLabels="true"
    />
  </div>
</template>
<script>
import cloudTemplate from '@/utils/templates/cloud.template';
import RDSGraph from '@/components/Cloud/Dashboard/Components/aws-metrics-graph.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { useRoute } from 'vue-router';
import { TEMPLATE_CLOUD_SVC } from '@/utils/constants';
import { SVC } from '@/components/Cloud/services/util';
import lambdaCharts from '@/utils/templates/cloudTemplates/aws/lambda.config';

const route = useRoute();
export default {
  name: 'IndividualGraphPage',
  components: {
    RDSGraph,
  },
  data() {
    return {
      awsTemplates: cloudTemplate,
      graphLegends: '',
      databaseInstances: [],
      graphIndex: parseInt(this.$route.params.graphName),
    };
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime']),
    getGraphTemplate() {
      return lambdaCharts().lineChartsSubscriptionPage[this.graphIndex];
    },
  },
  methods: {
    ...mapActions('cloudState/detail', ['fetchAwsServiceInstances']),
    ...mapMutations('cloudState/detail', [
      'setCurrentPage',
      'setCurrentService',
      'setCurrentServiceInstance',
    ]),
    ...mapMutations('globalState/app', ['setTemplate']),
    ...mapMutations('cloudState/services', ['setCurrentSvc']),
    async fetchGraphLegends() {
      const serviceId = this.$route.params.serviceId;

      let databaseCluster = {
        duration: this.getDurationTime,
        serviceId,
      };
      const databaseInstance =
        await this.fetchAwsServiceInstances(databaseCluster);

      this.databaseInstances = databaseInstance.map((instance) => ({
        label: instance.label,
        value: instance.key,
        key: instance.key,
      }));
      let instanceLabels = this.databaseInstances.map((option) => option.value);

      this.graphLegends = this.databaseInstances
        .map((instance) => instance.label)
        .join(', ');

      this.setCurrentServiceInstance(instanceLabels);
    },
  },
  beforeMount() {
    this.setCurrentPage('subscriptionId');
    this.setCurrentService(this.$route.params.serviceId);
    this.setTemplate(TEMPLATE_CLOUD_SVC);
    this.setCurrentSvc(SVC.LAMBDA);
    this.fetchGraphLegends();
  },
  watch: {
    getDurationTime() {
      this.fetchGraphLegends();
    },
  },
};
</script>
